export enum UserRoles {
    ANONYMOUS = 'anonymous',
    HOST = 'host',
    GUEST = 'guest',
}

export enum MusicProviders {
    SPOTIFY = 'spotify',
}

export enum AuthProviders {
    NONE = 'none',
    SPOTIFY = 'spotify',
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
}

export interface IFBUserProfile {
    id: string;
    displayName: string;
    photoURL: string;
    email: string;
}
